module.exports = {"title":"Já vamos enviar seu extrato.","description":"Diga pra gente o e-mail em que você quer receber seu extrato.","buttonText":"Continuar","error":{"invalid":"Campo inválido"},"defaultError":"Erro."}


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/InputModal/data.json
// module id = 2294
// module chunks = 0